import type { ImpressionType } from '@/ImpressionType'

export const impressionDataExtraLucide: ImpressionType = {
  title: 'Extra-Lucide',
  impressionContent: `
<p>
Il y a des idées qui semblent stupide.<br/>
Comme laisser sa famille nettoyer une scène de suicide...<br/><br/>
</p>

<p>
Voilà comment je fus embarqué dans une opération sensible, kafkaïenne.<br/>
La vie est parfois pleine de surprises, situation rocambolesque, ou le tragique confine a l'absurde.<br/><br/>
</p>

<p>
Ou l'on assume, encore et toujours des situations ubuesque que nous légue nos anciens.<br/><br/>
</p>

<p>
Notre pire cauchemar fut donc une baignoire.<br/>
La salle de bain ? Une scène de crime.<br/>
On comprend alors comment un simple lieu peut devenir hanté.<br/>
Comment un objet anodin s'entoure d'une aura mystique. <br/><br/>
</p>

<p>
Après la coupe du Christ, la baignoire de ma soeur.<br/>
Dieu sait qu'elle eut apprécié la portée liturgique de cette situation !<br/><br/>
</p>


<p>
Et on comprend aussi notre corps, son pragmatisme, sa pertinence a nous dire "cette situation... C'est pas bon !".<br/><br/>
</p>

<p>
Soit, au diable ces signaux, on se prépare a faire le sal boulot !<br/>
La situation est connu, l'objectif ? Définis.<br/>
Vider la baignoire, éviter d'en mettre partout.<br/>
Qu'est ce que nous trouverons ?<br/>
Aucune idée.<br/><br/>
</p>

<p>
Une certitude : c'est ici que son âme quitta sa chaire.<br/><br/>
<p>

<p>
Sur ce champ de bataille épique, j'etalerai, une fois de plus, la qualité de mon impeccable éducation d'homme moderne ! Taire ces sentiments. Gèrer la situation.<br/><br/>
<p>

<p>
Nous embarquons, mère et moi, dans cette opération amphibie.<br/><br/>
<p>

<p>
1, 2, 3, une porte qui s'ouvre.<br/>
Tout se suite, l'odeur.. indescriptible et légère.. celle de la mort.<br/><br/>
<p>

<p>
Est-ce réel ou juste l'idée que l'on s'en fait ? Non ne réfléchis pas. Robotique.<br/><br/>
<p>

<p>
Baignoire = eau = vider eau.<br/><br/>
<p>

<p>
A gauche ? Mère tétanisé.<br/><br/>
</p>

<p>
Dire une connerie pour se détendre ? Fait.<br/><br/>
</p>

<p>
Vite trouvé du réel : baignoire, bouchon, tuyau, ok, bouchon enlevé, écoulement, Ok.<br/><br/>
</p>

<p>
Objectif atteint, vortex formé, vidange en cours.<br/><br/>
</p>

<p>
Mais... Ça prend du temps ?<br/>
Alors on note les détails :<br/>
- tuyau déjà bien orienté et près a usage.. c'est préparé.<br/>
- on vérifie la baignoire... Oula.<br/><br/>
</p>

<p>
Oui "Oula".<br/>
Parce que cette scène contient encore des traces.<br/>
Trace de vie, et de mort...<br/><br/>
</p>

<p>
Qu'est ce donc ? Des feuilles de papier ? On les attrape...<br/><br/>
</p>

<p>
Et haletant, c'est un texte.<br/>
Ne rien dire, pour éviter à mon père cette douleur.<br/>
Ma mère, entre "qu'est ce qui est marqué" et "jette ça".<br/> 
On déchifre... Est-ce sont dernier texte.. un autre... Encore ? Et ça ? Sont écriture.. pourquoi écrit-elle en gros... Elle qui a toujours écrit petit.<br/><br/>
</p>

<p>
Tout se bouscule, on cherche une trace, une explication, elle. Un peu d'elle.<br/><br/>
</p>

<p>
L'eau coule.<br/><br/>
</p>

<p>
Un peu d'elle, ses mots, ses lettres qui grossissent, sa peur..<br/><br/>
</p>

<p>
Tenir ces mots, c'est tenir sa peur, son angoisse.<br/><br/>
</p>

<p>
Cette eau ? Son linceul.<br/>
Ces mots ? Comme des larmes de cyan.<br/>
Du cyan ? Donc c'est écrit.<br/>
Un regard.<br/>
Là un stylo.<br/>
Couleur enclenché ? Cyan.<br/>
Stylo pourpre c'est mignon.. ça lui ressemble.<br/><br/>
</p>

<p>
Pas penser.<br/><br/>
</p>

<p>
L'eau coule.<br/><br/>
</p>

<p>
Encore une feuille, mais tout glisse, et se désagrège sous mes doigts.<br/>
Pas penser, regarde, lire, lire tout, courir après toi, une trace de toi.<br/><br/>
</p>

<p>
Et sous mes yeux,<br/>
Toi, ton écriture qui part, ta main qui a du se dérober..<br/>
La dernière trace que tu es laissé sur terre.<br/>
Ton écriture qui casse, quand la vie te quitte.<br/>
Tes mains tremble, tu es toi aussi en dehors de ton corps.<br/><br/>
</p>

<p>
La feuille colle.<br/><br/>
</p>

<p>
Tu regardes encore, ces cassure, comme une effusion, de sang, de cyan, une brisure, une fenêtre sur ton monde.<br/><br/>
</p>

<p>
L'angoisse, tu étais bouffé d'angoisse, de peur, tu étais seule<br/><br/>
</p>

<p>
Et cette photo que je n'ai pas envoyé. Jamais, jamais je ne te reverrai.<br/><br/>
</p>

<p>
Jamais je ne pourrai t'aider.<br/><br/>
</p>

<p>
Impossible de bouger les doigts, tout se désagrège. Tu file, comme la vie, vers le néant, l'abîme, la poubelle.<br/><br/>
</p>

<p>
"Tu arrives a lire quelques choses ?"<br/><br/>
</p>

<p>
"Non"<br/><br/>
</p>

<p>
"Jette ça, il ne faut pas que ton père voit ça".<br/><br/>
</p>

<p>
L'eau ne coule plus.<br/><br/>
</p>

<p>
La mort dans l'âme tu me quittes.<br/><br/>
</p>

<p>
Tu étais la, seul, angoissée.. face a la mort, seule.<br/><br/>
</p>

<p>
Pourquoi tu m'as rien dit.<br/>
Pourquoi je n'étais que filigrane.<br/>
Pourquoi je me retrouve la.<br/><br/>
</p>

<p>
Le stylo, couleur enfoncé, avec toi.<br/>
Impossible a tenir.<br/>
</p>

<p>
"Jette le"<br/><br/>
</p>

<p>
Jetté.<br/><br/>
</p>

<p>
Et ça.<br/><br/>
</p>

<p>
Une figurine ?? Minnie ?!<br/>
Une figurine d'enfantine.<br/>
Qu'est ce que ça fout la !??<br/>
</p>

<p>
Je penche la baignoire.<br/><br/>
</p>

<p>
C'est un peu lourd, je ressens quelques choses.<br/><br/>
</p>

<p>
L'eau coule..<br/><br/>
</p>

<p>
Était ce avec toi ? Est ce cassé par hasard.<br/><br/>
</p>

<p>
"C'était un jouet de ta sœur.. ô mon dieu".<br/><br/>
</p>

<p>
Ramassé, pas jeté.<br/><br/>
</p>

<p>
L'eau coule.<br/><br/>
</p>

<p>
L'eau coule.<br/><br/>
</p>

<p>
L'eau coule moins.<br/><br/> 
</p>

<p>
L'eau ne coule plus.<br/><br/>
</p>

<p>
"On laisse la baignoire sécher, je récupérer cette merde plus tard".<br/><br/>
</p>

<p>
"D'accord".<br/><br/>
</p>

<p>
On sort.<br/><br/>
</p>

<p>
Je tremble.<br/>
Je tremble.<br/><br/>
</p>

<p>
Tu ne méritait pas ça.<br/>
Je tremble.<br/><br/>
</p>

<p>
La dernière trace écrite sur terre c'est moi qui est posé les yeux dessus.<br/><br/>
</p>

<p>
Ma soeur...<br/><br/>
</p>

---


<p>
Ton angoisse face a moi ce cyan, tout.<br/>
Tout est toujours là.<br/><br/>
</p>

<p>
C'est ton petit frère qui garde ça en lui.<br/>
</p>
  `,
  illustrationCaption: 'Imprimé',
  illustrationCopyright: 'Source: openai',
  illustrationPath: '/img/impressions/extra-lucide-1.jpg',
  noteEntries: [
    "Horreur"
  ]
}
